
export const pageURLs = Object.freeze({
    root: '',
    signup: 'signup',
    forgotpassword_step1: 'forgotpassword-step1',
    forgotpassword_step2: 'forgotpassword-step2',
    forgotpassword_step3: 'forgotpassword-step3',
    dashboard: 'dashboard',
    hardware_details: "hardware-details",
    manage_carwash: "manage-carwash",
    manage_subscriptions: "manage-subscriptions",
    add_subscription: "add-subscription",
    add_buy_ups: "add-buy-ups",
    edit_buyups: "edit-buy-ups",
    add_self_serve_subscription:"add-self-serve-subscription",
    edit_subscription: "edit-subscription",
    add_carwash: "add-carwash",
    edit_carwash: "edit-carwash",
    carwash_locations: "carwash-locations",
    add_relaynumber: "add-relaynumber",
    add_buyup_relaynumber: "add-buyup-relaynumber",
    equipment_listing: "equipment-listing",
    signup_process: "signup-process",
    add_location: "add-location",
    edit_location: "edit-location",
    add_equipment: "add-equipment",
    edit_equipment: "edit-equipment",
    my_profile: "my-profile",
    manage_promotions: "manage-promotions",
    add_promotion: "add-promotion",
    edit_promotion: "edit-promotion",
    manage_advertisements: "manage-advertisements",
    add_video_advertisements: "add-video-advertisements",
    add_image_advertisements: "add-image-advertisements",
    add_advertisements: "add-advertisements",
    edit_advertisements: "edit-advertisements",
    referral_program: "referral-program",
    order_list: "order-list",
    track_order: "track-order",
    track_orders: "track-orders",
    order_details: "order-details",
    manage_hardware: "manage-hardware",
    marketing_package: "marketing-package",
    addnew_hardware: "addnew-hardware",
    edit_hardware: "edit-hardware",
    addnew_package: "addnew-package",
    edit_package: "edit_package",
    manage_admin_subscription: "manage_admin_subscription",
    add_admin_subscription: "add_admin_subscription",
    edit_admin_subscription: "edit_admin_subscription",
    admin_users: "admin-users",
    addnew_user: "addnew-user",
    edit_user: "edit-user",
    revenue_reports: "revenue-reports",
    revenue_summary_report: "revenue-summary-report",
    pax_revenue_reports: "pax-revenue-reports",
    user_visit_details_report: "user-visit-details-report",
    userconversion_reports: "user-conversion-reports",
    campaign_reports:"campaign-reports",
    customer_support_desk: "customer-support-desk",
    support_chat: "support-chat",
    manage_users: "manage-users",
    cwo_signup: "cwo-signup",
    cwo_signup_process: "cwo-signup-process",
    order_history: "order-history",
    order_hardware: "order-hardware",
    payment_success: "payment-success",
    cwo_bankinformation: "cwo-bankinformation",
    cwo_paymentinformation: "cwo-paymentinformation",
    cwo_addticket: "cwo-addticket",
    cwo_emailtemplates: "cwo-emailtemplate",
    cwo_emailtemplate1: "cwo-emailtemplate/template-1",
    cwo_emailtemplate2: "cwo-emailtemplate/template-2",
    cwo_emailtemplate3: "cwo-emailtemplate/template-3",
    cwo_emailtemplate4: "cwo-emailtemplate/template-4",
    cwo_edittemplate: "cwo-edittemplate",
    cwo_referral_program: "cwo-referral-program",
    location_managers: "location-managers",
    transaction_history: "transaction-history", 
    add_cwo_user: "add-location-manager",
    edit_cwo_user: "edit-location-manager",
    cwo_app_settings: "cwo-app-settings",
    cwo_signup_bank_information: "cwo-bank-information",
    set_password: "setpassword",
    manage_campaigns: "manage-campaigns",
    add_campaign: "add-campaign",
    edit_campaign: "edit-campaign",
    carwash_sign_generation: "carwash-sign-generation",
    carwash_small_sign_generation: "carwash-small-sign-generation",
    cwo_text_settings: "cwo-text-settings",
    edit_self_serve_subscription:"edit_self_serve_subscription",
    multilocation_usage_reports:"multilocation_usage_reports",
    monthly_single_purchase_report:"monthly-single-purchases-report",
    monthly_membership_purchase_report:"monthly-membership-purchase-report",
    membership_monthly_report:"membership-monthly-report",
    user_activity_report:"user-activity-report",
    family_fleet_plan:"family-fleet-plan",
    membership_report:"membership-report",
    add_bulk_singlewash:"add-bulk-singlewash",
    edit_bulk_singlewash:"edit-bulk-singlewash",
    pax_device_listing: "pax-device-listing",
    lpr_device_listing: "lpr-device-listing",
    fleet_management: "fleet-management",
    gift_card_management: "gift-card-management",
    loyalty_program_management: "loyalty-program-management"
})